import * as React from 'react';

import { translate } from '~l10n/client';

import { PaywallTouchEventAdapter } from '~analytics/adapters/PaywallTouchEventAdapter';
import { PaywallScreens } from '~analytics/types';
import { UIButton } from '~shared/components/buttons';
import { DialogProps } from '~shared/components/Dialog';
import {
  PaywallDialog,
  PaywallUpgradeButton,
} from '~teacher/components/PaywallDialog';

export interface Props extends Pick<DialogProps, 'open' | 'onClose'> {
  paywallScreen: PaywallScreens;
}

export function SharedLibraryPaywall({
  paywallScreen,
  open,
  onClose,
  ...props
}: Props) {
  React.useEffect(() => {
    if (open) {
      new PaywallTouchEventAdapter(paywallScreen).sendAnalytics();
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars,react-hooks/exhaustive-deps
  }, []);

  return (
    <PaywallDialog.Long
      id="shared-library-paywall"
      open={open}
      onClose={onClose}
      title={translate('Upgrade to Use Shared Library')}
      actions={[
        <UIButton key="cancel" onClick={onClose}>
          {translate('Cancel')}
        </UIButton>,
        <PaywallUpgradeButton
          key="upgrade"
          appearance="primary"
          paywallScreen={paywallScreen}
        />,
      ]}
      closeLabel={translate('Close')}
      {...props}
      paywallTouch={[paywallScreen]}
    >
      <p className="m-0 pb-4 text-blue-900">
        {translate(
          'Shared libraries let you create, edit, and share quizzes with your peers.'
        )}
      </p>
    </PaywallDialog.Long>
  );
}
